module.exports = __webpack_public_path__ + "3572b40521c434a47ef2f6ad85a9ff49.svg";